module.exports = __webpack_public_path__ + "static/MATLABCert-dfcf28ee0ad54017d6c35a029896d661.jpg";